import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/sxFileStorage/page',
    method: 'get',
    params: params
  })
}

export function save (params) {
  return axios({
    url: '/sxFileStorage/save',
    method: 'post',
    data: params
  })
}
export function update (params) {
  return axios({
    url: '/sxFileStorage/update',
    method: 'post',
    data: params
  })
}

export function getObj (id) {
  return axios({
    url: '/sxFileStorage/' + id,
    method: 'get'
  })
}

export function delObj (id) {
  return axios({
    url: '/sxFileStorage/' + id,
    method: 'delete'
  })
}
